/**
 * Maps a BinomOffer (catalog row) → BinomDraftItem (drawer state). Used by
 * the offer picker on submit.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { BinomOffer } from '@/hooks/binom';

import type { BinomDraftItem } from '../../../binom-flow-draft.types';

export function offerToDraftItem(o: BinomOffer): BinomDraftItem {
  return {
    id: o.id,
    name: o.name,
    weight: 100,
    originalWeight: 100,
    active: true,
    originalActive: true,
  };
}
